import { render, staticRenderFns } from "./SummaryReportTable.vue?vue&type=template&id=61179558&"
import script from "./SummaryReportTable.vue?vue&type=script&lang=js&"
export * from "./SummaryReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports